import { ChangeDetectorRef, Component, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService, LanguageService } from '@spartacus/core';
import { Observable, Subscription } from 'rxjs';
import { CheckAvailabilityDialogComponent } from '../../kb-product-list/check-availability-dialog/check-availability-dialog.component';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { DocumentSpecificSearchService } from '../../kb-CustomDocumentSearchTab/document-specific-search.service';
import { CustomerIdService } from 'src/app/services/feature/customerId/customer-id.service';
import { CookieService } from 'src/app/customServices/cookie.service';
import { KbGetAQuoteService } from '../../kb-Get-A-Quote/kb-get-aquote/kb-get-aquote.service';
import { CurrentProductService } from '@spartacus/storefront';
import { ProductDetailsService } from 'src/app/customServices/product-details.service';
import { CartTrackingService } from 'src/app/customServices/cart-tracking.service';
import { HreflangService } from 'src/app/services/hreflang.service';
import { combineLatest } from 'rxjs';
import { map, filter } from 'rxjs/operators';
import { ActiveCartFacade } from '@spartacus/cart/base/root';
@Component({
  selector: 'app-kb-product-details',
  templateUrl: './kb-product-details.component.html',
  styleUrls: ['./kb-product-details.component.scss'],
  encapsulation: ViewEncapsulation?.None,
  standalone: false
})
export class KbProductDetailsComponent {
  isLoggedIn: boolean = false;
  productDetails$: Observable<any> = this.currentProdService.getProduct();
  currentLang: string;
  productCode: any;
  fleetPrideGroup: any;
  product$: Observable<any>;
  subscription = new Subscription();
  constructor(
    private currentProdService: CurrentProductService,
    private langService: LanguageService,
    public pdpService: ProductDetailsService,
    private activateRoute: ActivatedRoute,
    public authService: AuthService,
    private router: Router,
    private dialog: MatDialog,
    private docService: DocumentSpecificSearchService,
    public custIDService: CustomerIdService,
    private cookieService: CookieService,
    private getaQuoteService: KbGetAQuoteService,
    private cdr: ChangeDetectorRef,
    private cartTrackingService: CartTrackingService,
    private hreflangService: HreflangService,
    private activeCartService: ActiveCartFacade,
  ) {
    this.WebTrekk_viewProduct();
  }
  ngOnInit() {
    this.docService.inPdp = true;
    this.subscription.add(this.authService.isUserLoggedIn().subscribe((isLoggedIn) => {
      this.isLoggedIn = isLoggedIn;
    }));


    this.subscription.add(this.langService.getActive().subscribe((x) => {
      this.productDetails$ = this.currentProdService.getProduct();
    }));

    this.subscription.add(this.custIDService.fleetPrideGroup$.subscribe((x) => {
      this.fleetPrideGroup = x;
      this.cdr.detectChanges();
    }));
    this.subscription.add(this.activateRoute.params.subscribe((data) => {
      this.productCode = data?.['productCode'];
      this.hreflangService.loadAndSetLinks(this.productCode);
    }));
  }

  WebTrekk_viewProduct() {
    /*  this.subscription.add(this.activateRoute.params.subscribe((data) => {
       this.productCode = data?.['productCode'];
       this.cartTrackingService.viewedProduct(this.productCode, 1);
     })); */
    this.subscription?.add(
      combineLatest([
        this.activateRoute.params.pipe(
          map(params => params?.['productCode'])
        ),
        this.activeCartService.getActive().pipe(
          filter((cart: any) => !!cart?.currentB2BUnit?.uid)
        )
      ]).subscribe(([productCode, cart]: [string, any]) => {
        this.productCode = productCode;

        this.cartTrackingService.viewedProduct(
          productCode,
          1,
          cart.currentB2BUnit.uid
        );
        console.log(productCode, cart.currentB2BUnit.uid);
      })
    );

  }
  checkAvailability(productCode) {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = true;
    dialogConfig.panelClass = 'check-availability-popup';
    dialogConfig.data = { productCode, page: 'PDP' };
    const dialogRef = this.dialog.open(CheckAvailabilityDialogComponent, dialogConfig);
  }

  createAQuote(productId) {
    const custId = this.cookieService.getCookieValue(`customerIdNA`);
    if (this.cookieService.checkItemSessionStorage(custId)) {
      const quoteId = this.cookieService.getItemSessionStorage(custId);
      this.subscription.add(this.getaQuoteService.createQuoteId(productId, false, quoteId).subscribe((res: any) => {
        this.routeToQuotePage(res.code);
      }));
    } else {
      this.subscription.add(this.getaQuoteService.createQuoteId(productId, true).subscribe((res: any) => {
        this.cookieService.setItemSessionStorage(custId, res?.code);
        this.routeToQuotePage(res.code);
      }));
    }
  }
  routeToQuotePage(quoteId) {
    this.router.navigate(['quote'], { queryParams: { code: quoteId } });
  }
  ngOnDestroy() {
    this.docService.inPdp = false;
    // Unsubscribe from the scroll event
    this.subscription.unsubscribe();

  }
}
